module.exports = __webpack_public_path__ + "static/media/fedpapers-brand.dac81428.png";